import * as React from "react";
import { useHistory, useLocation } from "react-router";

interface INavigationContext {
  navigateWithBackReference: (route: string) => void;
  goBack: (defaultRoute: string) => void;
  clearBackRoute: () => void;
  backReference?: string | null;
}

const NavigationContext = React.createContext<INavigationContext>(null!);

interface INavigationProviderProps {}

export const NavigationProvider: React.FunctionComponent<
  INavigationProviderProps
> = ({ children }) => {
  const history = useHistory();

  const location = useLocation();

  const [previousPage, setPreviousPage] = React.useState<string | null>();

  const navigateWithBackReference = React.useCallback(
    (route: string) => {
      setPreviousPage(location.pathname);
      // Capture current page
      history.push(route);
    },
    [history, location.pathname]
  );

  const goBack = React.useCallback(
    (defaultRoute: string) => {
      if (previousPage) {
        history.push(previousPage);
        setPreviousPage(null);
      } else {
        history.push(defaultRoute);
      }
    },
    [history, previousPage]
  );

  const clearBackRoute = React.useCallback(() => {
    setPreviousPage(null);
  }, []);

  return (
    <NavigationContext.Provider
      value={{
        navigateWithBackReference,
        goBack,
        clearBackRoute,
        backReference: previousPage,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationContext = () => React.useContext(NavigationContext);
